// Topic lessons come from the server, for the website and the app alike
// (language-graphql-neo4j-database/lib/topicLessons.js has the rules): the
// hand-written lesson, or the shared one explained in the learner's own
// language — written for their language pair the first time it's needed.
// Writing one takes a minute or two on the Mac Studio, so these wait for it.
import {
  START_TOPIC_LESSON_MUTATION, TOPIC_LESSON_QUERY, START_PERSONAL_LESSON_MUTATION, PERSONAL_LESSON_QUERY,
} from '../query/gqlQueries'

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

async function waitFor(client, start, poll, field, pollField, onProgress) {
  let state = (await client.mutate(start)).data[field]
  const began = Date.now()
  while (state.status === 'generating') {
    if (onProgress) onProgress(Math.round((Date.now() - began) / 1000))
    await sleep(3000)
    state = (await client.query({ ...poll, fetchPolicy: 'network-only' })).data[pollField]
  }
  if (state.status !== 'ready' || !state.meetingId) throw new Error(state.error || 'The lesson couldn’t be written — try again.')
  return state.meetingId
}

/** The topic lesson that fits me — or, with student, a student of mine. fresh: the owner's rebuild. Resolves to its meetingId. */
export function topicLessonFromServer(client, { topicId, student, fresh, onProgress }) {
  const variables = { topicId, student: student || null }
  return waitFor(
    client,
    { mutation: START_TOPIC_LESSON_MUTATION, variables: { ...variables, fresh: fresh || null } },
    { query: TOPIC_LESSON_QUERY, variables },
    'startTopicLesson', 'topicLesson', onProgress,
  )
}

/** My private version of a topic's lesson. fresh: write a new one. Resolves to its meetingId. */
export function personalLessonFromServer(client, { topicId, fresh, onProgress }) {
  return waitFor(
    client,
    { mutation: START_PERSONAL_LESSON_MUTATION, variables: { topicId, fresh: fresh || null } },
    { query: PERSONAL_LESSON_QUERY, variables: { topicId } },
    'startPersonalLesson', 'personalLesson', onProgress,
  )
}
